<div #box class="box">
  <div class="box-row header">
    @if (software) {
    <app-header-bar [autoTranslateTitle]="false" [title]="software.name || ''" [backRoute]="software.type?.id ? '/software/type/' + software.type!.id : '/software'"></app-header-bar>
    }
  </div>

  <div class="d-none d-md-flex justify-content-between align-items-center mt-2 mb-4">
    <span class="flex-grow-1 d-flex align-items-center">
      {{"search" | translate}}:
      <input type="text" class="form-control ms-3 me-2" [placeholder]="'software.artifact.searchContent' | translate" #search />
    </span>

    @if (artifacts.length > 0) {
        @if (showCompactViewToggle) {
          <div class="compact-button d-flex align-items-center">
            <span class="me-2">{{"software.compactView" | translate}}:</span>
            <div class="form-check form-switch form-switch-lg">
              <input class="form-check-input" type="checkbox" role="switch"
                [attr.checked]="showAllChangelogs ? null : 'checked'" (change)="showAllChangelogs = !showAllChangelogs">
            </div>
          </div>
        }

        @if (isScrollable) {
          <button class="btn btn-secondary ms-2" (click)="scrollToVersions()">
            <span class="material-symbols-outlined">
              arrow_downward
            </span>
            <span>{{ 'software.allVersions' | translate }}</span>
          </button>
        }
    }
  </div>

  <div class="d-flex d-md-none flex-column m-2">
    @if (artifacts.length > 0) {
      <div class="d-flex flex-row justify-content-between mb-2">
        @if (showCompactViewToggle) {
          <div class="compact-button d-flex align-items-center">
            <span class="me-2">{{"software.compactView" | translate}}:</span>
            <div class="form-check form-switch form-switch-lg">
              <input class="form-check-input" type="checkbox" role="switch"
                [attr.checked]="showAllChangelogs ? null : 'checked'" (change)="showAllChangelogs = !showAllChangelogs">
            </div>
          </div>
        }
        @if (isScrollable) {
          <button class="btn btn-secondary ms-2 ps-1 pe-1" (click)="scrollToVersions()">
            <span class="material-symbols-outlined">
              arrow_downward
            </span>
            <span>{{ 'software.allVersions' | translate }}</span>
          </button>
        }
      </div>
    }

    <div class="d-flex flex-row">
      <span class="flex-grow-1 d-flex flex-grow-1 align-items-center">
        {{"search" | translate}}:
        <input type="text" class="form-control ms-3 software-search" [placeholder]="'software.artifact.searchContent' | translate" #searchMin />
      </span>
    </div>
  </div>

  @if (software && latestArtifact) {
    <app-software-detail-header [software]="software" [artifact]="latestArtifact" (scrollToVersions)="scrollToVersions()"
      [isAdmin]="isAdmin">
    </app-software-detail-header>
  }

  <h2 id="artifact_anchor" class="ms-2 ms-md-0">
    @if (search.value || searchMin.value) {
      {{ 'software.artifact.searchResults' | translate }}
    } @else {
      {{ 'software.allVersions' | translate }}
    }
  </h2>
  @for (artifact of artifacts; track artifact.id) {
    <app-software-artifact [id]="'artifact-' + artifact.id" [artifact]="artifact" [isAdmin]="isAdmin"
      [showChangelogAlways]="showAllChangelogs" (edit)="edit(artifact.id)">
    </app-software-artifact>
  }
  @if (loadedItems < totalItems) {
    <button class="btn btn-outline-primary mb-3" (click)="loadMore()">
      {{ 'software.loadMore' | translate }}
    </button>
  }

  @if (!loading && artifacts.length === 0) {
    <app-empty-table [icon]="'deployed_code'"
      [emptyText]="'software.artifact.empty_text' | translate"></app-empty-table>
  }

  <app-model-modal #EditModal (saveEvent)="onSave()">
    <app-software-artifact-form (closeEvent)="onModalClose()"
      (loadingEvent)="onLoading($event.valueOf())"></app-software-artifact-form>
  </app-model-modal>
</div>
